var map = {
	"./VideoCreatorHelper": [
		660,
		9
	],
	"./VideoCreatorHelper.ts": [
		660,
		9
	],
	"./templates/template1": [
		1421,
		3,
		12
	],
	"./templates/template1.json": [
		1421,
		3,
		12
	],
	"./templates/template2": [
		1420,
		3,
		11
	],
	"./templates/template2.json": [
		1420,
		3,
		11
	],
	"./templates/video-motion-v2": [
		1419,
		3,
		10
	],
	"./templates/video-motion-v2.json": [
		1419,
		3,
		10
	],
	"./templatesList": [
		1088,
		3,
		5
	],
	"./templatesList.json": [
		1088,
		3,
		5
	],
	"./typings": [
		371,
		9
	],
	"./typings.ts": [
		371,
		9
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1980;
module.exports = webpackAsyncContext;